import React from 'react'

function Heading({title,icon}) {
  return (
    <>

      <div className="card-bg mb-3">
        <div className="card bg-black head-line mb-2">
          <div className="text-light d-flex p-2 py-3 justify-content-center align-items-center">
            
            <div className="faTrophy"> {icon} </div>

            <h4 className="mx-3 text-white p-2">{title}</h4>

          </div>
        </div>
      </div>

    </>
  )
}

export default Heading
